import React, { useCallback, useEffect } from "react";
import Menu from "./menu/menu";
import { useDispatch, useSelector } from "react-redux";
import { getMode, modeSet } from "../redux/layoutSlice";
import { ref, update } from "firebase/database";
import { firebaseDb } from "../firebase/app";
import { branchUidSet, buyAgentSet, getOriginUid, getUid } from "../redux/authSlice";
import LightModeRoundedIcon from "@mui/icons-material/LightModeRounded";
import DarkModeRoundedIcon from "@mui/icons-material/DarkModeRounded";
import LogoutIcon from "@mui/icons-material/Logout";
import LogOut from "../sections/auth/logout";
import { getData } from "../utils/firebase";
import { branchNameSet, getRole, roleSet } from "../redux/userSlice";
import { LocationOn } from "@mui/icons-material";

export default function NavMenu({
  anchorEl,
  handleClose,

  handleOpenBranchMenu,
  branches,
  setBranches,
}: any) {
  // const [branchAnchorEl, setBranchAnchorEl] = React.useState<null | HTMLElement>(null);

  const dispatch = useDispatch();
  const mode = useSelector(getMode);
  const uid = useSelector(getUid);
  const originUid = useSelector(getOriginUid);

  const [openLogout, setOpenLogout] = React.useState(false);

  const role = useSelector(getRole);

  const branchUidStorage = localStorage.getItem("branchUid");
  // const branchUidStorage = false;

  const changeTheme = () => {
    dispatch(modeSet(mode === "dark" ? "light" : "dark"));
    localStorage.setItem("colorMode", mode === "dark" ? "light" : "dark");
    handleClose();
    const data = {
      theme: mode === "dark" ? "light" : "dark",
    };
    const userPreferences = {
      darkMode: mode === "dark" ? false : true,
    };
    localStorage.setItem("userPreferences", JSON.stringify(userPreferences));
    update(ref(firebaseDb, `dealers/${uid}/info/dashboardSettings`), data);

    // for pwa
    const newTheme = mode === "dark" ? "light" : "dark";
    const themeColor = newTheme === "dark" ? "#000000" : "#ffffff";
    const metaThemeColor = document.querySelector("meta[name=theme-color]");
    if (metaThemeColor) {
      metaThemeColor.setAttribute("content", themeColor);
    } else {
      const meta = document.createElement("meta");
      meta.name = "theme-color";
      meta.content = themeColor;
      document.head.appendChild(meta);
    }
  };

  const handleLogout = () => {
    handleClose();
    setOpenLogout(!openLogout);
  };

  // const handleCloseMenu = () => {
  //   setBranchAnchorEl(null);
  //   handleClose();
  // };

  // const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
  //   setBranchAnchorEl(event.currentTarget);
  // };

  const getBranches = useCallback(() => {
    getData(`Users/${originUid}`)
      .then((data: any) => {
        if (!data) {
          return;
        }
        //TODO: set branches and role
        const branchesData = data.branches
          ? Object.entries(data.branches).map(([key, item]: any) => ({
              dealerName: item,
              dealerUid: key,
              product: "sales agent",
            }))
          : [];
        const buyBranchesData = data.buyBranches
          ? Object.entries(data.buyBranches).map(([key, item]: any) => ({
              dealerName: item,
              dealerUid: key,
              product: "buy agent",
            }))
          : [];
        setBranches([...branchesData, ...buyBranchesData]);
        if (!branchUidStorage) {
          const newBranchUid =
            branchesData.length > 0 ? branchesData[0].dealerUid : buyBranchesData[0].dealerUid;
          const newBranchName =
            branchesData.length > 0 ? branchesData[0].dealerName : buyBranchesData[0].dealerName;
          dispatch(branchUidSet(newBranchUid));
          dispatch(branchNameSet(newBranchName));
          const buyagentStatus = branchesData ? false : true;
          dispatch(buyAgentSet(buyagentStatus));
          localStorage.setItem("branchUid", newBranchUid);
          localStorage.setItem("branchName", newBranchName);
          localStorage.setItem("product", buyagentStatus ? "sales agent" : "buy agent");
        } else {
          dispatch(branchUidSet(branchUidStorage));
        }
        dispatch(roleSet(data.role));
      })
      .catch((err) => console.log(err));
  }, [branchUidStorage, dispatch, originUid, setBranches]);

  useEffect(() => {
    getBranches();
  }, [getBranches]);

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        handleClose={handleClose}
        anchorOrigin={{ vertical: 50, horizontal: "right" }}
        items={[
          ...(role === "admin" && branches && branches.length > 0
            ? [
                {
                  label: "Locations",
                  icon: <LocationOn sx={{ fontSize: "20px" }} />,
                  onClick: handleOpenBranchMenu,
                },
              ]
            : []),
          {
            label: mode === "dark" ? "Light" : "Dark",
            icon:
              mode === "dark" ? (
                <LightModeRoundedIcon sx={{ fontSize: "20px" }} />
              ) : (
                <DarkModeRoundedIcon sx={{ fontSize: "20px" }} />
              ),
            onClick: changeTheme,
          },
          {
            label: "Log Out",
            icon: <LogoutIcon sx={{ fontSize: "20px" }} />,
            onClick: handleLogout,
            sx: {
              // borderTop: "1px solid #e5e5e5",
              // borderTopLeftRadius: "0",
              // borderTopRightRadius: "0",
            },
          },
        ]}
      />
      <LogOut open={openLogout} handleClose={handleLogout} />
    </>
  );
}
